import { getFileTypeMappings } from "../Functions";
import _ from "lodash";

export function ImportAndPreviewFile(this: any): any {
  const profileName =
    _.find(getFileTypeMappings(this.creditors, this.creditor), {
      inputFileType: this.fileType,
    })?.mappingProfileName || "";

  return {
    fileType: this.fileType,
    creditor: this.creditor,
    file: this.fileList,
    profileName,
  };
}
